import { Component } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import {
  Asset,
  ContentBlock,
  AudioBlock,
} from "src/app/shared/model/container.models";
import { UtilitiesService } from "src/app/shared/services/utilities/utilities.service";
import { includes } from "lodash";
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModelComponent } from 'src/app/shared/components/confirmation-model/confirmation-model.component';
import { Modalconfig } from 'src/app/shared/constants';

const extensionAllowedArray = ["mp3"];

@Component({
    selector: "app-edit-audio",
    templateUrl: "./edit-audio.component.html",
    styleUrls: ["./edit-audio.component.scss"],
    standalone: false
})
export class EditAudioComponent {
  contentBlock: ContentBlock;
  audBlock: AudioBlock;
  onclose = new Subject();
  showProgress = false;
  progressPercent = 0;
  confModalRef: BsModalRef;
  confModalSubsciber: Subscription;
  constructor(
    private utilitiesService: UtilitiesService,
    private commonHttpService: CommonHttpService,
    private modalService: BsModalService
  ) {}


  /**
   * To set the audio asset if available
   */
   getAudioAsset(isEdit) {
    if (isEdit) {
      if (this.audBlock && this.audBlock.assetId) {
        return `/api/Assets/GetResourceById/${this.audBlock.assetId}`;
      }
    } else {
      if (this.contentBlock.audioBlock && this.contentBlock.audioBlock.assetId) {
        return `/api/Assets/GetResourceById/${this.contentBlock.audioBlock.assetId}`;
      }
    }
    return '';
  }

  /**
   * To open file input for uploading file based on file type
   * @param fileType File type
   */
  openFileDialog() {
    $("#uploadMp3").trigger("click");
  }

  /**
   * Method to handle validation of resource type before uploading
   * @param selectedFile File data for upload
   * @param fileType File type
   */
  fileSelected(event) {
    const selectedFile = event.target.files[0];
    if (this.checkExtensionFunction(selectedFile)) {
      this.uploadResource(selectedFile);
    } else {
      const initialState = {
        msg: "This is not a valid extension. Supported extension is: mp3",
        showCancelBtn: false,
      };
      this.confModalRef = this.modalService.show(
        ConfirmationModelComponent,
        Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
      );
      this.confModalSubsciber = this.confModalRef.content.onclose.subscribe(
        (res) => {
          this.confModalRef.hide();
          this.confModalSubsciber.unsubscribe();
        }
      );
    }
  }

  checkExtensionFunction(selectedFile) {
    const extensionArray = selectedFile.name.split(".");
    const extension = extensionArray[extensionArray.length - 1].toLowerCase();
    return includes(extensionAllowedArray, extension);
  }

  /**
   * Method to upload resource to database
   * @param selectedFile File data for upload
   * @param fileType File type
   */
  uploadResource(selectedFile) {
    const formData = new FormData() as any;
    this.showProgress = true;
    formData.append("file", selectedFile);
    this.commonHttpService
      .postWithProgress({
        uri: "/api/Assets/UploadResource",
        object: formData,
      })
      .subscribe((response: Asset | number) => {
        if (typeof response === "number") {
          this.progressPercent = response;
        } else if (response) {
          const fileReader = new FileReader();
          fileReader.readAsDataURL(selectedFile);
          fileReader.onload = (e) => {
            this.audBlock.assetId = response.id;
            this.audBlock.asset = response;
            this.progressPercent = 0;
            this.showProgress = false;
          };
        }
      });
  }

  /**
   * To add or update audioBlock
   */
  updateAudioBlock() {
    let reqObj = {
      assetId: this.audBlock.external ? null : this.audBlock.assetId,
      caption: this.audBlock.caption,
      external: this.audBlock.external,
      altAssetId: this.audBlock.altAssetId,
    };
    this.closeEditAudioModal(reqObj);
  }

  closeEditAudioModal(reqObj = null) {
    this.onclose.next(reqObj);
    setTimeout(() => {
      this.progressPercent = 0;
      this.showProgress = false;
    }, 1000);
  }

  getAssetAzureUrl(assetUrl) {
    this.utilitiesService.getAssetAzureUrl(assetUrl);
  }
}
